import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Target, Users, Award } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Shield className="h-6 w-6 text-primary" data-id="element-72" />,
    title: 'Безпека та Стандарти',
    description: 'Впровадження міжнародних стандартів безпеки UIAA.'
  }, {
    icon: <Target className="h-6 w-6 text-primary" data-id="element-73" />,
    title: 'Спортивні Досягнення',
    description: 'Організація чемпіонатів та підготовка збірних команд.'
  }, {
    icon: <Users className="h-6 w-6 text-primary" data-id="element-74" />,
    title: 'Спільнота',
    description: "Об'єднання спортсменів та любителів гір по всій країні."
  }, {
    icon: <Award className="h-6 w-6 text-primary" data-id="element-75" />,
    title: 'Освіта',
    description: 'Проведення навчальних зборів та шкіл інструкторів.'
  }];
  return <section id="about" className="py-20 bg-white relative overflow-hidden border-b border-gray-100" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-78">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-79">
            <span className="text-primary/60 font-semibold tracking-wider uppercase text-xs" data-id="element-80">
              Про Федерацію
            </span>
            <h2 className="mt-2 text-3xl md:text-4xl font-heading font-bold text-primary leading-tight" data-id="element-81">
              Що таке ФАіСУ?
            </h2>
            <p className="mt-6 text-base text-gray-600 leading-relaxed" data-id="element-82">
              Федерація Альпінізму і Скелелазіння України (ФАіСУ) — це
              всеукраїнська громадська організація, що має статус Національної
              спортивної федерації. Ми є єдиним офіційним представником України
              в Міжнародному союзі альпіністських асоціацій (UIAA) та
              Міжнародній федерації спортивного скелелазіння (IFSC).
            </p>
            <p className="mt-4 text-base text-gray-600 leading-relaxed" data-id="element-83">
              Наша місія — розвиток альпінізму, скелелазіння та льодолазіння в
              Україні, популяризація здорового способу життя та представлення
              українських спортсменів на міжнародній арені.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6" data-id="element-84">
              {features.map((feature, index) => <div key={index} className="flex flex-col" data-id="element-85">
                  <div className="mb-3 p-2 bg-gray-50 rounded-lg w-fit border border-gray-100" data-id="element-86">
                    {feature.icon}
                  </div>
                  <h3 className="text-base font-bold text-primary mb-1" data-id="element-87">
                    {feature.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-snug" data-id="element-88">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-89">
            <div className="grid grid-cols-2 gap-4" data-id="element-90">
              <div className="space-y-4 mt-8" data-id="element-91">
                <img src="https://images.unsplash.com/photo-1522163182402-834f871fd851?w=800&q=80" alt="Rock Climbing" className="rounded-lg shadow-md w-full h-56 object-cover grayscale-[20%]" data-id="element-92" />
                <img src="https://images.unsplash.com/photo-1505567745926-ba89000d255a?w=800&q=80" alt="Alpinism Gear" className="rounded-lg shadow-md w-full h-40 object-cover grayscale-[20%]" data-id="element-93" />
              </div>
              <div className="space-y-4" data-id="element-94">
                <img src="https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=800&q=80" alt="Mountain Summit" className="rounded-lg shadow-md w-full h-40 object-cover grayscale-[20%]" data-id="element-95" />
                <img src="https://images.unsplash.com/photo-1564769662533-4f00a87b4056?w=800&q=80" alt="Ice Climbing" className="rounded-lg shadow-md w-full h-56 object-cover grayscale-[20%]" data-id="element-96" />
              </div>
            </div>

            {/* Stats Badge */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary text-white p-5 rounded-lg shadow-lg border-2 border-white text-center" data-id="element-97">
              <span className="block text-3xl font-bold font-heading" data-id="element-98">
                1991
              </span>
              <span className="text-xs text-white/70 uppercase tracking-wider" data-id="element-99">
                Рік заснування
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}